import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';

const styles = {
  employersModal: {
    minHeight: '40rem',
    maxHeight: '70vh',
    maxWidth: '109rem',
  },
  employersWrapper: {
    margin: '3rem auto 5rem',
    textAlign: 'start',
  },
  employerForm: {
    textAlign: 'start',
    marginTop: '4rem',
  },
  cancelButton: { margin: '4rem auto 0' },
  noDataMessage: {
    marginTop: '4rem',
    color: colors.neutral[900],
    fontWeight: 700,
  },
  groupAdminSection: {
    marginBottom: '5rem',
  },
  groupAdminSectionLabel: {
    fontSize: '1.4rem',
    textTransform: 'uppercase',
    color: colors.blue[600],
    fontWeight: 700,
    marginBottom: '2rem',
  },
  employerSectionLabel: {
    fontSize: '1.4rem',
    textTransform: 'uppercase',
    color: colors.neutral[900],
    fontWeight: 700,
    marginBottom: '2rem',
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
